/**
 * Check whether the given payment provider is supported
 *
 * @param   {String}  payment
 *
 * @return  {Boolean}
 */
export default (payment = '') => ['STRIPE', 'MONEYPLATFORM'].includes(payment.toUpperCase());
